import find from 'lodash/find';
import isEqual from 'react-fast-compare';
import maxBy from 'lodash/maxBy';
import minBy from 'lodash/minBy';

import { ActionType, ActionTypes } from '../../actions/index';
import { PriceType } from '../../classes/price-type';
import { IExchangeTicket } from '../../classes/ticket-exchange';
import { IAppState } from '../../reducers/index';
import { fetchSeatMatches } from './filter-fetch';

export interface IFilterStateAction {
    type: ActionType;
    value?: any;
}

/*
 * action creators
 */

export function ADAOnlySeatsModalProceedClick(result) {
    return {
        type: ActionTypes.ADA_ONLY_SEATS_PROCEED_CLICK,
        value: result
    }
}

export function selectSeatingOptions(seatingOptionGroupId: string, seatingOptions: Array<any>, seatingOptionToggle: boolean) {
    return (dispatch, state) => {
        let nextState: IAppState = state();
        let selectedOptionGroup = nextState.additionalSeatingOptionModel.additionalSeatingOptions.filter(options => options.id == seatingOptionGroupId);

        if (selectedOptionGroup.length > 0 && selectedOptionGroup[0].groupSeatSelectedQuantity === 0) {
            dispatch({ type: ActionTypes.ADD_ADDITIONAL_SEATING_OPTION_QUANTITY, value: { seatingOptionGroupId, quantity: 1 } });
        }
        dispatch({ type: ActionTypes.ADD_ADDITIONAL_SEATING_OPTION_IDS, value: { seatingOptionGroupId, selectedOptions: seatingOptions, seatingOptionToggle } });
        dispatch(fetchSeatMatches());
    }
}

export function selectSeatingOptionQuantity(seatingOptionGroupId: string, quantity: number) {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.ADD_ADDITIONAL_SEATING_OPTION_QUANTITY, value: { seatingOptionGroupId, quantity } });
        dispatch(fetchSeatMatches());
    }
}

export function selectPriceTypeTicketsWithSeatingOption(priceTypeId: number, seatingOptionGroupId: string, quantity: number, updatePriceRange: boolean, activeExchangeTickets: Array<IExchangeTicket>, trackGAEvent: boolean) {
    return (dispatch, state) => {
        dispatch({
            type: ActionTypes.SELECT_PRICE_TYPE_TICKETS, value: { priceTypeId, quantity }, unTrackEvent: !trackGAEvent
        });

        dispatch({ type: ActionTypes.ADD_ADDITIONAL_SEATING_OPTION_QUANTITY, value: { seatingOptionGroupId, quantity } });

        dispatch(setPriceRange(updatePriceRange, activeExchangeTickets, []));
        dispatch(fetchSeatMatches());
    };
}
export function updateAdditionalNotes(additionalNotes: string) {
    return {
        type: ActionTypes.UPDATE_ADDITIONAL_NOTES,
        value: additionalNotes
    }
}

export function clearAdditionalSeatRequest() {
    return (dispatch, state) => {
        let currentState: IAppState = state();
        dispatch({ type: ActionTypes.CLEAR_ADDITIONAL_SEAT_REQUEST });
        let nextState: IAppState = state();

        if (!isEqual(currentState, nextState))
            dispatch(fetchSeatMatches());
    }
}

export function removeSeatingOptionGroup(seatingOptionGroupId: string) {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.REMOVE_ADDITIONAL_SEATING_OPTION, value: seatingOptionGroupId });
        dispatch(fetchSeatMatches());
    }
}

export function selectPriceTypeTickets(priceTypeId: number, quantity: number, updatePriceRange: boolean, activeExchangeTickets: Array<IExchangeTicket>, trackGAEvent: boolean) {
    return (dispatch, state) => {
        dispatch({
            type: ActionTypes.SELECT_PRICE_TYPE_TICKETS, value: { priceTypeId, quantity }, unTrackEvent: !trackGAEvent
        });

        dispatch(setPriceRange(updatePriceRange, activeExchangeTickets, []));
        dispatch(fetchSeatMatches());
    };
}

export function setPriceRange(updatePriceRange: boolean, activeExchangeTickets: Array<IExchangeTicket>, priceTypesToUse: Array<PriceType>) {
    return (dispatch, state) => {
        let currentState: IAppState = state();

        let priceTypes = currentState.appSettingsModel.priceTypeSettings as Array<PriceType>;
        let defaultPriceType = find(priceTypes, 'isDefault');

        if (defaultPriceType === undefined && priceTypes.length > 0) {
            defaultPriceType = priceTypes[0];
        }

        let combinedPriceTypes = currentState.priceTypesModel.priceTypes.filter(pt => pt.selectedQuantity > 0).concat(defaultPriceType);

        if (priceTypesToUse.length > 0) {
            combinedPriceTypes = priceTypesToUse;
        }

        let min = minBy(combinedPriceTypes, pt => { return pt.minTotalPrice });
        let max = maxBy(combinedPriceTypes, pt => { return pt.maxTotalPrice });

        //if (activeExchangeTickets.length > 0) {
        //    min.minPrice = calculateExchangePrice(min.minPrice, activeExchangeTickets);
        //    max.maxPrice = calculateExchangePrice(max.maxPrice, activeExchangeTickets);
        //}
        dispatch({
            type: ActionTypes.UPDATE_MIN_MAX_PRICE_RANGE, value: { min, max, updatePriceRange }
        });
    };
}

export function toggleSeatSeparation(toggleFlag: boolean) {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.TOGGLE_SEAT_SEPARATION, value: toggleFlag });
        dispatch(fetchSeatMatches());
    };
}

export function toggleAisleAccess(toggleFlag: boolean) {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.TOGGLE_AISLE_ACCESS, value: toggleFlag });
        dispatch(fetchSeatMatches());
    };
}

export function loadPriceTypeFilters(priceTypes: Array<PriceType>, useOnlyPromoPriceType) {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.LOAD_PRICE_TYPES, value: { priceTypes, useOnlyPromoPriceType } });
        priceTypes.forEach(pt => {
            if (pt.clientMinQuantity > 0) {
                dispatch(selectPriceTypeTickets(pt.priceTypeId, pt.clientMinQuantity, false, [], false));
            }
            if (pt.defaultSelectedQuantity > 0 && pt.defaultSelectedQuantity > pt.clientMinQuantity)
                dispatch(selectPriceTypeTickets(pt.priceTypeId, pt.defaultSelectedQuantity, false, [], false));
        });
    };
}

export function loadPriceRangeFilters(priceTypes, useOnlyPromoPriceType) {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.LOAD_DEFAULT_PRICE_RANGE, value: { priceTypes, useOnlyPromoPriceType } });
    };
}

export function loadAdditionalSeatingOptions(additionalSeatingOptions, renderAisleSeatToggle) {
    return (dispatch, state) => {
        var additionSeatingOptionModel = {
            additionalSeatingOptions: additionalSeatingOptions,
            renderAisleSeatToggle: renderAisleSeatToggle
        };

        dispatch({
            type: ActionTypes.LOAD_ADDITIONAL_SEAT_REQUESTS, value: additionSeatingOptionModel
        });
    }
}

export function selectVenueLevel(levelNumber: number) {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.TOGGLE_VENUE_LEVEL, value: levelNumber });
        dispatch(fetchSeatMatches());
    };
}

export function resetVenueLevels() {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.RESET_VENUE_LEVELS });
        dispatch(fetchSeatMatches());
    };
}

export function loadVenueLevelFilters(venueLevels) {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.LOAD_VENUE_LEVELS, value: venueLevels });
    };
}